import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef, useEffect, useState } from "react";

const industries = [
  {
    title: "Travel & Airport Parking",
    description:
      "We create innovative solutions to simplify booking and enhance travel experiences with real-time updates and secure transactions.",
  },
  {
    title: "E-Commerce",
    description:
      "Delivering scalable platforms that drive sales, enhance customer engagement, and ensure seamless transactions.",
  },
  {
    title: "Food",
    description:
      "We streamline food services with user-friendly interfaces and efficient operational processes.",
  },
  {
    title: "Technology",
    description:
      "Innovative and future-ready solutions designed to optimize business operations and ensure growth.",
  },
  {
    title: "Business Management",
    description:
      "Providing customized CRM and ERP solutions to improve efficiency, automate processes, and enhance decision-making.",
  },
];

export default function Partner() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div className=" relative">
      <div className="max-w-[1280px] mx-auto md:px-10 px-5 md:py-7 py-5"  style={{
          backgroundImage: "url('/light-service.png')",
          backgroundSize: '80% ',
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
        <div className=""  >
        
       
          <h2 className="text-3xl md:text-5xl small:text-4xl font-bold text-center text-black">
          Partnering  for   Long-Term Success    </h2>
        <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
          <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
        </div>
        <p className="text-center text-black mt-2 small:w-[80%] mx-auto">
        We don’t just build solutions — we build partnerships. Our
            commitment extends beyond launch, ensuring that your platform
            remains secure, updated, and optimized as your business grows. At
            Binary Ops,   we’re invested in your success every step of the way.        </p>
        </div>
      </div>
      <div
        className="relative md:bg-cover !bg-cover "
        style={{
          backgroundImage: "url('/last-section.png')",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="max-w-[1280px] mx-auto md:px-10 px-5  relative ">
          <Swiper
            modules={[Navigation]}
            navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
            spaceBetween={20}
            slidesPerView={1.2}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
            className="relative"
            onSwiper={setSwiperInstance}
          >
            {industries.map((industry, index) => (
              <SwiperSlide key={index}>
                <div className="relative group  border-r-[1px] border-white overflow-hidden h-[350px]">
                  <div className="absolute inset-0 flex items-end transition-opacity duration-300 group-hover:bg-opacity-70">
                    <div className="group relative overflow-hidden p-4">
                      <h3 className="text-xl font-bold translate-y-0 text-white group-hover:-translate-y-4 transition-all duration-500">
                        {industry.title}
                      </h3>
                      <p className="text-sm mt-2 opacity-0 translate-y-[20px] hidden transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:translate-y-0 group-hover:block text-white">
                        {industry.description}
                      </p>
                      {/* <button className="mt-4 px-4 py-2 bg-primary text-white hidden font-bold rounded opacity-0 translate-y-4 transition-all duration-500 ease-in-out group-hover:opacity-100 group-hover:translate-y-0 group-hover:block">
                        Read More
                      </button> */}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Navigation Buttons */}
          <div className="absolute top-0 right-0 flex gap-2 p-4 z-10">
            <button
              ref={prevRef}
              className="p-3 rounded-full bg-white shadow-lg hover:bg-orange-400 hover:text-white transition-all duration-300"
            >
              <FaChevronLeft className="text-gray-800 text-lg group-hover:!text-white" />
            </button>
            <button
              ref={nextRef}
              className="p-3 rounded-full bg-white shadow-lg hover:bg-orange-400 hover:text-white transition-all duration-300"
            >
              <FaChevronRight className="text-gray-800 text-lg group-hover:!text-white" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
